import { render, staticRenderFns } from "./CalendarDateStripSmartGroup.vue?vue&type=template&id=63f98be8&"
import script from "./CalendarDateStripSmartGroup.vue?vue&type=script&lang=js&"
export * from "./CalendarDateStripSmartGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VRow})
